import { useMemo } from 'react';
import { transformDataForTable, transformVisibilityResultsForTable } from 'utils/agendaRecord/agendaRecord.ts';
import type { AgendaRecordItem, GetAgendaRecordsRes, InlineRecordType } from 'types';

interface UseAgendaTableDataProps {
  data: GetAgendaRecordsRes<AgendaRecordItem[]>;
  shouldSkipFetch?: boolean;
  overrideValues?: InlineRecordType[];
  calculatedValues?: Record<string, unknown>;
}

export const useAgendaTableData = ({ data, shouldSkipFetch, overrideValues, calculatedValues }: UseAgendaTableDataProps) => {
  const transformedData = useMemo(() => {
    if (shouldSkipFetch) return [];

    const baseData = transformDataForTable(data.items, overrideValues);

    if (!calculatedValues || Object.keys(calculatedValues).length === 0) {
      return baseData;
    }

    return baseData.map((row) => {
      const calculatedRowData = calculatedValues[row.identifier];
      if (calculatedRowData) {
        return {
          ...row,
          ...calculatedRowData,
        };
      }
      return row;
    });
  }, [data, shouldSkipFetch, overrideValues, calculatedValues]);

  const visibilityResults = useMemo(() => transformVisibilityResultsForTable(data), [data]);

  return { transformedData, visibilityResults };
};
